// withRouter shim for React Router v7+.
// Injects navigate, location, and params into class components that used
// the v5 withRouter HOC or received route props via <Route render=...>.
import React from 'react'
import { useNavigate, useLocation, useParams } from 'react-router'

export function withRouter(Component) {
    return function WithRouterWrapper(props) {
        const navigate = useNavigate()
        const location = useLocation()
        const params = useParams()
        // Build a v5-compatible history object so class components need minimal changes.
        const history = {
            push: (to, state) => {
                if (to && typeof to === 'object') {
                    navigate(to.pathname ?? to, { state: to.state ?? state })
                } else {
                    navigate(to, { state })
                }
            },
            replace: (to, state) => {
                if (to && typeof to === 'object') {
                    navigate(to.pathname ?? to, { replace: true, state: to.state ?? state })
                } else {
                    navigate(to, { replace: true, state })
                }
            },
            go: (n) => navigate(n),
            goBack: () => navigate(-1),
            goForward: () => navigate(1),
            location,
        }
        return <Component {...props} history={history} location={location} match={{ params, path: location.pathname, url: location.pathname }} />
    }
}
